import React from 'react';
import { Calendar, ArrowRight } from 'lucide-react';
const placeholderPosts = [{
  title: 'The Importance of Reality-Based Training for First Responders',
  date: 'March 15, 2026',
  excerpt: 'Exploring why hands-on, scenario-driven training remains the gold standard for law enforcement preparedness and how agencies can implement effective programs.',
  tag: 'Training'
}, {
  title: 'Active Shooter Preparedness: What Every Organization Should Know',
  date: 'February 28, 2026',
  excerpt: 'A comprehensive look at the critical steps businesses and educational institutions must take to develop robust emergency response plans.',
  tag: 'Corporate Safety'
}, {
  title: 'New Jersey Concealed Carry: What Civilians Need to Know in 2026',
  date: 'January 20, 2026',
  excerpt: 'An overview of the latest regulations, training requirements, and best practices for responsible concealed carry in the state of New Jersey.',
  tag: 'Civilian'
}];
export function PostsSection() {
  return <section className="py-16 md:py-24 bg-brand-black" data-id="element-211">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-212">
        <div className="space-y-8" data-id="element-213">
          {placeholderPosts.map(post => <article key={post.title} className="group border border-brand-gray-800 bg-brand-gray-900 p-8 hover:border-brand-teal/50 transition-colors cursor-pointer" data-id="element-214">
              <div className="flex items-center gap-4 mb-4" data-id="element-215">
                <span className="text-xs font-bold uppercase tracking-wider text-brand-teal border border-brand-teal/30 bg-brand-teal/10 px-2 py-0.5" data-id="element-216">
                  {post.tag}
                </span>
                <span className="flex items-center gap-1.5 text-sm text-brand-gray-500" data-id="element-217">
                  <Calendar className="w-3.5 h-3.5" data-id="element-218" />
                  {post.date}
                </span>
              </div>
              <h2 className="text-2xl font-bold text-brand-white uppercase tracking-wide mb-3 group-hover:text-brand-teal transition-colors" data-id="element-219">
                {post.title}
              </h2>
              <p className="text-brand-gray-400 leading-relaxed mb-4" data-id="element-220">
                {post.excerpt}
              </p>
              <span className="inline-flex items-center text-sm font-bold uppercase tracking-wider text-brand-gray-500 group-hover:text-brand-teal transition-colors" data-id="element-221">
                Read More <ArrowRight className="ml-1.5 w-4 h-4" data-id="element-222" />
              </span>
            </article>)}
        </div>

        <div className="text-center mt-16 text-brand-gray-500 text-sm" data-id="element-223">
          More posts coming soon.
        </div>
      </div>
    </section>;
}